import React from "react";

import ImpactTable from "./ImpactTable";
import { TimeRangeImpactType } from "./type";

type TopImpactProps = {
  highImpact: TimeRangeImpactType[];
};
const TopImpact = (props: TopImpactProps) => {
  const { highImpact } = props;

  return <ImpactTable impact={highImpact} />;
};

export default TopImpact;
